export default "__VITE_ASSET__B$FKag0j__"